import React from "react";
import { Outlet, Link, useLocation, matchPath } from "react-router-dom";
import { Box, Tabs, Tab, Container, Select, MenuItem } from "@mui/material";

const tabs = [
  { path: "", label: "Seed Test Data" },
];

export default function DevTools() {
  const location = useLocation();
  const { pathname } = location;

  const routes = tabs.map((tab) => tab.path);
  const currentRoute = routes.find((route) => {
    if (route === "") {
      return matchPath({ path: "/dev-tools", end: true }, pathname);
    }
    return matchPath({ path: `/dev-tools/${route}`, end: false }, pathname);
  });

  const tabsValue = currentRoute !== undefined ? currentRoute : false;

  return (
    <Box>
      <Container>
        <Box
          sx={{
            borderBottom: 1,
            borderColor: "divider",
            backgroundColor: "primary.light",
            marginTop: 2,
          }}
        >
          <Select
            value={currentRoute ?? ""}
            sx={{
              marginLeft: "5px",
              marginRight: "5px",
              marginBottom: "5px",
              display: { xs: "block", sm: "block", md: "none" },
            }}
          >
            {tabs.map(({ path, label }) => (
              <MenuItem key={path} value={path} component={Link} to={path === "" ? "/dev-tools" : `/dev-tools/${path}`}>
                {label}
              </MenuItem>
            ))}
          </Select>
          <Tabs
            value={tabsValue}
            aria-label="Dev Tools navigation"
            sx={{
              display: { xs: "none", sm: "none", md: "block" },
            }}
          >
            {tabs.map(({ path, label }) => (
              <Tab
                key={path}
                label={label}
                component={Link}
                to={path === "" ? "/dev-tools" : `/dev-tools/${path}`}
                value={path}
              />
            ))}
          </Tabs>
        </Box>
        <Outlet />
      </Container>
    </Box>
  );
}
